import { render, staticRenderFns } from "./activity-star-pick.vue?vue&type=template&id=709780f3&scoped=true&"
import script from "./activity-star-pick.vue?vue&type=script&lang=js&"
export * from "./activity-star-pick.vue?vue&type=script&lang=js&"
import style0 from "./activity-star-pick.vue?vue&type=style&index=0&id=709780f3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709780f3",
  null
  
)

export default component.exports